import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { Question, QuestionTypes } from 'onboarding/question/Question';
import { Info } from '../info/Info';
import { TextOption } from '../options/TextOption';

export class LivenOptionalQuestion extends Question {
  sourceQuestionId: QuestionIds;
  options: Record<string, LivenOptionQuestion | Info>;

  constructor(
    sourceQuestionId: QuestionIds,
    questionId: QuestionIds,
    options: Record<string, LivenOptionQuestion | Info>,
    hasStepper?: boolean,
    hasHeader?: boolean,
  ) {
    super(
      QuestionTypes.Optional,
      questionId,
      (hasHeader = false),
      hasStepper ??
        Object.values(options)[0].type === QuestionTypes.LivenOption,
    );
    this.hasHeader = hasHeader;
    this.sourceQuestionId = sourceQuestionId;
    this.options = options;
  }
}

export class LivenOptionQuestion extends Question {
  title: string;
  description?: string;
  options: TextOption[];
  multiple: boolean;
  withIcon?: boolean;
  note?: { title: string; decription: string };

  constructor(
    id: QuestionIds,
    title: string,
    options: TextOption[],
    multiple = false,
    hasStepper = true,
    hasHeader?: boolean,
    description?: string,
    withIcon?: boolean,
    note?: { title: string; decription: string },
  ) {
    super(QuestionTypes.LivenOption, id, hasStepper, hasHeader);

    this.id = id;
    this.title = title;
    this.description = description;
    this.options = options;
    this.multiple = multiple;
    this.withIcon = withIcon;
    this.note = note;
  }

  hasOptionId(id: string): boolean {
    for (const option of this.options) {
      if (option.id === id) {
        return true;
      }
    }
    return false;
  }
}
